import SignIn from '../mutations/SignIn.gql'

export default function (variables) {
  return {
    mutation: SignIn,
    variables: variables,
  }
}
